import React, { useState } from 'react';

import AdminBlogAuthors from '../AdminBlogAuthors/AdminBlogAuthors';
import AdminBlogCategories from '../AdminBlogCategories/AdminBlogCategories';

import './AdminBlogMetadata.css';

const AdminBlogMetadata = () => {
  const [activeTab, setActiveTab] = useState('authors');

  return (
    <div className='admin-blog-metadata-container'>
      <div className='admin-blog-metadata-title-container'>
        <h1 className='admin-blog-metadata-categories-title'>
          Blog Management
        </h1>
      </div>
      <div className='admin-blog-metadata-tabs-and-entity-container'>
        <div className='admin-blog-metadata-tabs-container'>
          <button
            className={activeTab === 'authors' ? 'active' : ''}
            onClick={() => setActiveTab('authors')}
          >
            Authors
          </button>
          <button
            className={activeTab === 'categories' ? 'active' : ''}
            onClick={() => setActiveTab('categories')}
          >
            Categories
          </button>
        </div>

        {activeTab === 'authors' && <AdminBlogAuthors />}
        {activeTab === 'categories' && <AdminBlogCategories />}
      </div>
    </div>
  );
};

export default AdminBlogMetadata;
